import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import React from "react";
import TokenSelection from "../TokenSelection/TokenSelection";
import TokenSelectionReceive from "../TokenSelection/TokenSelectionReceive";

const ReceiveCard = ({
  labelName,
  cardStyle,
  paletteMode,
  dropdownRef2,
  selectedToken2,
  setIsOpen2,
  isOpen2,
  tokens,
  swapTokens,
  handleTokenChange,
  getFormattedBalance,
  newMax,
  newOnChangeSwapInputs,
  selectedToken,
  receiveValue,
  formatBalanceForPrice,
  safeParseNumber,
  pricemap,
  isIncreaseBalance,
}) => {
  return (
    <article
      className={"border border-deepBlue rounded-lg  pt-4 pb-6 w-full z-10"}
    >
      {/* "Receive" Label */}

      <div className="w-full">
        <div
          className={`px-6 pb-4 md:px-8 border-b ${
            paletteMode === "light"
              ? "border-lightBlue"
              : "border-darkSlateBlue"
          } dark:border-darkSlateBlue `}
        >
          <h3
            className={
              "leading-6 text-base text-black font-medium mb-3 dark:text-white"
            }
          >
            {labelName}
          </h3>

          <TokenSelectionReceive
            tokens={tokens}
            dropdownRef2={dropdownRef2}
            setIsOpen2={setIsOpen2}
            isOpen2={isOpen2}
            selectedToken2={selectedToken2}
            selectedToken={selectedToken}
            newOnChangeSwapInputs={newOnChangeSwapInputs}
            paletteMode={paletteMode}
            swapTokens={swapTokens}
            receiveValue={receiveValue}
            handleTokenChange={handleTokenChange}
            isIncreaseBalance={isIncreaseBalance}
          />
        </div>
      </div>

      {/* Token Selection and Balance */}

      <div className="w-full px-6 md:px-8 pt-3 flex flex-col gap-1 md:flex-row md:justify-between md:gap-0">
        {/* Token Balance */}

        <div className={"flex items-center gap-2 items-center"}>
          <p
            className={` text-xs 
            ${
              paletteMode === "light" ? "text-semiBlack" : "text-semiWhite"
            }  md:text-sm leading-[14.4px] md:leading-4 dark:text-semiWhite`}
          >
            Balance
          </p>
          <span className="flex-1 bg-lightGrayBlue h-[1px]  dark:bg-darkSlateBlue md:hidden" />
          <p
            className={` text-xs  md:text-sm leading-6 ${
              paletteMode === "light" ? "text-black" : "text-white"
            } dark:text-white`}
          >{`${
            getFormattedBalance(selectedToken2.name) === "0"
              ? "00.00"
              : getFormattedBalance(selectedToken2.name)
          } ${selectedToken2.name}`}</p>
        </div>

        <p
          className={`${
            paletteMode === "light" ? "text-semiBlack" : "text-semiWhite"
          }  text-xs  md:text-sm 
            leading-[14.4px] md:leading-4 flex items-center gap-2 dark:text-semiWhite`}
        >
          <p>Amount in USD</p>
          <span className="flex-1 h-[1px] bg-lightGrayBlue dark:bg-darkSlateBlue md:hidden" />
          <p
            className={`${
              paletteMode === "light" ? "text-black" : "text-white"
            } text-xs  md:text-sm leading-6 dark:text-white`}
          >
            ≈
            {formatBalanceForPrice(
              safeParseNumber(receiveValue) *
                safeParseNumber(pricemap[selectedToken2.name])
            ) === "0"
              ? "00.00"
              : formatBalanceForPrice(
                  safeParseNumber(receiveValue) *
                    safeParseNumber(pricemap[selectedToken2.name])
                )}
            $
          </p>
        </p>
      </div>
    </article>
  );
};

export default ReceiveCard;
